import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import PaginationControls from '@/views/pagination_controls';
import LineItemListView from '@/views/modules/billing_line_item_list';

    var apiCh = Radio.channel('api');

    let template = `
    <div class="row header">
        <div class="panel">
            <div class="panel-heading paginated">
                <div>
                    <h1 class="title">Pending Charges</h1>
                    <div>Not reflected in balance.</div>
                </div>
                <div class="pagination"></div>
            </div>
            <div class="panel-body">
                <div class="transactions"></div>
            </div>
        </div>
    </div>`;

    var empty_template = `<h3>This is where you'll find pending charges as they accrue.</h3>
                          <p>Payment is scheduled for the first of every month</p>`;

    var EmptyView = Marionette.View.extend({
        template: Handlebars.compile(empty_template),
        className: 'text-center placeholder',
        templateContext: function () {
            return {
                num_cols: this.options.num_cols || 1,
                message: this.options.message || 'Nothing'
            };
        }
    });

    var PlanDetailsWidget = Marionette.View.extend(LayoutMixin).extend({
        className: function(){ return "account widget " + this.getWidth(); },
        ui: {
            pagination: '.pagination',
            transactions: '.transactions'
        },
        regions: {
            pagination: '@ui.pagination',
            transactions: '@ui.transactions'
        },
        template: Handlebars.compile(template),
        modelEvents: {
            'change': 'render'
        },
        onRender: function(){
            let payments_collection = apiCh.request('lineitem');
            let collection = new Backbone.Collection({type: 'lineitem'});

            var pagination_controls = new PaginationControls({
                collection: payments_collection 
            });

            // filter[type] actual means filter[item_type]
            payments_collection.fetch({
                data: {
                    'page[size]': 50
                },
            })
            .done(pagination_controls.update_prev_next_from_response)
            .done((data) => {
                let items = [];
                if ( data && data.data ) {
                    data.data.forEach((r)=> {
                        let s = apiCh.request(r.type, r.id);
                        if (!s) {
                            payments_collection.add(r);
                            s = apiCh.request(r.type, r.id);
                        }
                        items.push(s);
                    });
                    transactions_table.collection.reset(items);
                    transactions_table.prep_list(items);
                }
            });

            let transactions_table = new LineItemListView({
                emptyView: EmptyView,
                collection: collection,
                collectionEvents: {
                    'add, remove, update': 'render',
                },
            });
            this.showChildView('pagination', pagination_controls);
            this.showChildView('transactions', transactions_table);
            pagination_controls.on({
                'page': function(filter, models) {
                    transactions_table.collection.reset(models);
                    transactions_table.render();
                }
            });
        }
    });

    export default PlanDetailsWidget;




